export class SelectListItem<T>{
    public id: T;
    public name: string = '';

    constructor(init?:Partial<any>){
        Object.assign(this, init);
    }
}